(function GroupAddForm($, Adzuki)
{
	"use strict";

	Adzuki.onload('Groups/add/', init);

	function init() {
		// test
	}
}(jQuery, window.Adzuki || {}));